import actions from 'constants/reducers';
import { IReducerFn } from 'context/type';
import { TModalsState } from './modals.type';

export const modalsReducer: IReducerFn<TModalsState> = (state, { type }) => {
  if (type === actions.modals.setOpenPurchaseExtraSuggestedTruckers) {
    return {
      ...state,
      isOpenPurchaseExtraSuggestedTruckers: true,
    };
  }

  if (type === actions.modals.setClosePurchaseExtraSuggestedTruckers) {
    return {
      ...state,
      isOpenPurchaseExtraSuggestedTruckers: false,
    };
  }

  return state;
};

modalsReducer.key = 'modals';
modalsReducer.initialState = {
  isOpenPurchaseExtraSuggestedTruckers: null,
};
